// Merchant onboarding progress (FIG-345 · UC-225).
//
// organisations.onboarding_state now drives sign-in, draft resume and anon
// draft edits; organisations.status is the admin-controlled relationship
// Status (src/shared/merchantStatus.ts). The generated Supabase types predate
// the column, so writes go through `withOnboardingColumns`.
import type { MerchantStatusId } from './merchantStatus';
import type { OnboardingState } from './types/onboarding';

export type { OnboardingState };

/** Columns added by the FIG-345 migration that src/integrations/supabase/types.ts doesn't list yet. */
export interface OnboardingColumns {
  onboarding_state?: OnboardingState;
  status?: MerchantStatusId;
}

export interface OnboardingSource {
  onboarding_state?: string | null;
  /** Legacy onboarding value on rows not yet migrated. */
  status?: string | null;
}

/**
 * Whether the merchant has submitted onboarding. Reads onboarding_state; on a
 * row from before the migration it falls back to the old rule (anything but
 * status 'draft' counted as submitted).
 */
export function hasSubmittedOnboarding(org: OnboardingSource | null | undefined): boolean {
  if (!org) return false;
  if (org.onboarding_state) return org.onboarding_state === 'submitted';
  return org.status !== 'draft';
}

/**
 * Adds the FIG-345 columns to an organisations insert/update payload while the
 * generated types are stale. `T` is the generated payload type.
 */
export function withOnboardingColumns<T extends object>(row: T, columns: OnboardingColumns): T {
  return { ...row, ...columns } as T;
}
